export default "__VITE_ASSET__rITgiKcd__"